import type { OnboardingTimeframe } from '../enums'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface OnboardingTimeframeReturn {
  label: string
  mode: ComputedRef<InputMode>
  setOnboardingTimeframe: (value: OnboardingTimeframe) => void
}

export const useOnboardingTimeframe = (): OnboardingTimeframeReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'In case you\'re selected for the role, how soon would you be able to complete a 3-hour-long onboarding training course covering: Brighterly overview, how to adopt Brighterly materials and use them to teach online, how to use Brighterly Teacher Room and other teaching tools, how to communicate effectively.'

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && tutorApplicationStore.form.onboardingTimeframe === null))
  
  const setOnboardingTimeframe = (value: OnboardingTimeframe): void => {
    tutorApplicationStore.setField('onboardingTimeframe', value)
  }

  return {
    mode,
    label,
    setOnboardingTimeframe,
  }
}
